<template>
  <div>
    <v-card :loading="loading" flat class="blueCard">
      <div class="ma-2">
        <div class="d-flex flex-row flex wrap align-center">
          <div class="d-flex flex-row flex-wrap align-center">
            <div class="text-h4 mr-4">Educational Images</div>
            <div class="text-h5 ml-2 pt-1" v-if="filters.category">
              ({{ filters.category | titleize }})
            </div>
          </div>
          <div v-if="selectedCategory" class="text-h5 pt-1">
            ({{ selectedCategory }})
          </div>
          <v-spacer></v-spacer>
        </div>
      </div>
    </v-card>

    <div v-if="imagesByCategory">
      <div v-for="(groupObj, i) in imagesByCategory" :key="i">
        <!-- {{ imageObjsForIndexes(groupObj.items) }} -->
        <div v-if="imageObjsForIndexes(groupObj.items).length">
          <div class="text-h5 mt-4 mb-2 categoryClass">
            {{ groupObj.category | titleize }}
          </div>
          <!-- <v-divider></v-divider> -->
          <dialog-lightbox
            :imagePath="image_path"
            :images="imageObjsForIndexes(groupObj.items)"
            imageKey="image"
            :iconHeight="500"
            :iconWidth="500"
            :maxWidth="$vuetify.breakpoint.name == 'sm' ? '40vw' : '250'"
            iconClass="ma-4"
            :openImage="openImage"
            position="center top"
            ><!--  captionKey="title" -->
            <!-- iconStyle="border: 1px solid lightgray" -->
          </dialog-lightbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import DialogLightbox from "@/components/universalStuff/DialogLightbox";
import FiltersMixin from "@/assets/js/cls/FiltersMixin.js";

export default {
  name: "EdImages",
  components: { DialogLightbox },
  mixins: [FiltersMixin],
  props: {},
  data: function () {
    return {
      loading: false,
      imagesData: null,
      meta: null,
      expandId: null,
      slug: null,
      selectedCategory: null,
      nameInput: null,
      filters: { name: null, category: null },
      openImage: null,
      image_path: "https://www.eyedock.com/images/educational-images/",
    };
  },
  methods: {
    getReferences() {
      this.loading = true;
      let params = null;

      ApiServices.ed_images(params)
        .then((response) => {
          this.imagesData = response.data.images;
          this.meta = response.data.meta;
          if (this.meta?.image_path) this.image_path = this.meta.image_path;
          if (!this.filters.category) this.setCategoryStore(null);
          // if (this.filters.name) this.nameInput = this.filters.name;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
          this.checkForSlug();
        });
    },
    // imagesForGroup: function (objArr) {
    //   let images = [];
    //   objArr.forEach((obj) => {
    //     images.push(obj.image);
    //   });
    //   return images;
    // },
    setCategoryStore(category) {
      this.$store.dispatch("setModeAndDetail", {
        mode: category,
        detail: null,
      }); // this.$store.state("mode", "vision");
    },
    imageObjsForIndexes(indexArr) {
      let rtn = [];
      indexArr.forEach((index) => {
        if (this.filteredIds.includes(index)) rtn.push(this.imagesData[index]);
      });
      return rtn;
    },
    checkForSlug() {
      // console.log("checkForSlug");
      if (this.filters.name) this.openImage = this.filters.name;
      // {
      //   let id = this.filters.name;
      //   console.log(id);

      //   this.$nextTick(() => {
      //     let el = document.getElementById(id);
      //     if (el) this.$vuetify.goTo(el, { offset: 20 });
      //   });
      // }
    },
  },
  computed: {
    widthForBreakpoint: function () {
      let rtn = "400";
      let screen = this.$vuetify.breakpoint.name;
      if (screen == "sm") rtn = "40vw";
      if (screen == "xs") rtn = "95vw";
      return rtn;
    },
    storeCategory: function () {
      return this.$store.state.mode;
    },
    title: function () {
      return null;
    },
    filteredIds: function () {
      let q = this.nameInput;
      if (q == "") q = null;
      let iObjs = this.imagesData;
      let allIds = [...iObjs.keys()];
      let category = this.filters.category;
      //   let ids = [];
      let ids = allIds.filter((id) => {
        // console.log(id);
        let imgObj = iObjs[id];
        // if (q) {
        //   if (
        //     !imgObj.title.toLowerCase().includes(q) &&
        //     !imgObj.aliases.toLowerCase().includes(q) &&
        //     !imgObj.category.includes(q)
        //   )
        //     return false;
        // }
        if (category && category.toLowerCase() != imgObj.category) return false;
        return true;
      });
      return ids;
    },
    imagesByCategory() {
      let images = this.imagesData;
      let byCategory = this.meta?.byCategory;
      let categoryOrder = this.meta?.categoryOrder;
      if (!images || !byCategory || !categoryOrder) return null;
      let selectedCategory = this.selectedCategory
        ? this.selectedCategory
        : null;
      let rtn = [];
      categoryOrder.forEach((cat) => {
        if (!selectedCategory || cat == selectedCategory) {
          rtn.push({ category: cat, items: byCategory[cat] });
        }
      });

      return rtn;
    },
  },
  watch: {
    storeCategory(val) {
      this.filters.category = val;
      // this.filters.name = null;
      this.$nextTick(() => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });

      // console.log(val);
    },
  },
  mounted() {
    //  this.selectedCategory = selectedCategory ? selectedCategory : null;
    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    this.getReferences();
    this.setFiltersFromHash();
    // console.log(this.filters);
    this.setCategoryStore(this.filters.category);
    // if (this.filters.name) this.nameInput = this.filters.name;

    // this.prepend_F = false;
  },
  metaInfo() {
    return {
      title: "EyeDock/Educational Images " + (this.title ? this.title : ""),
    };
  },
};
</script>

<style scoped>
.categoryClass {
  background-color: #bfe7ff;
  padding: 5px 7px;
  border-radius: 3px;
  /* border: 1px solid #00264f; */
}
</style>
